import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, X } from "lucide-react";
import type { ReactNode } from "react";

interface Props {
  id: string;
  children: ReactNode;
  onRemove?(): void;
}

export default function SortableItem({ id, children, onRemove }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };
  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center gap-2 px-2 py-1.5 bg-gh-surface border border-gh-border rounded mb-1 text-sm"
    >
      <button
        {...attributes}
        {...listeners}
        className="text-gh-muted cursor-grab active:cursor-grabbing"
        aria-label="drag"
      >
        <GripVertical className="w-4 h-4" />
      </button>
      <div className="flex-1">{children}</div>
      {onRemove && (
        <button
          onClick={onRemove}
          aria-label="remove"
          className="text-gh-muted hover:text-gh-danger"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
